// Define mywork constants

module.exports = {
  MYWORK_FILTER_AI: 'MYWORK_FILTER_AI',
  MYWORK_STATUS_AI: 'MYWORK_STATUS_AI',
  MYWORK_EFFORT_AI: 'MYWORK_EFFORT_AI',
  MYWORK_START_DATE_AI: 'MYWORK_START_DATE_AI',
  MYWORK_END_DATE_AI: 'MYWORK_END_DATE_AI',
  MYWORK_REMINDER_AI: 'MYWORK_REMINDER_AI',
  MYWORK_RATING_AI: 'MYWORK_RATING_AI',
  MYWORK_DELEGATE_AI: 'MYWORK_DELEGATE_AI',
  MYWORK_PRIORITY_AI: 'MYWORK_PRIORITY_AI',
  MYWORK_DELETE_AI: 'MYWORK_DELETE_AI',
  MYWORK_AI_NEW: 'MYWORK_AI_NEW',
  MYWORK_AI_UPDATE: 'MYWORK_AI_UPDATE',
  MYWORK_AI_DRAG_DROP: 'MYWORK_AI_DRAG_DROP',
  MYWORK_FILTER_ID: 'MYWORK_FILTER_ID',
  MYWORK_RELOAD_DATA: 'MYWORK_RELOAD_DATA'
};
